import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { handleExport } from '../../../../helpers/export'
import portfolioScoreService from '../../core/service'

export const getHighestCreditRisk = createAsyncThunk(
  'portfolioInsights/score/topCompanies/getHighestCreditRisk',
  async (params, { rejectWithValue }) => {
    try {
      const res = await portfolioScoreService.getHighestCreditRisk(params)
      if (res.success) {
        return res.data
      }
      return rejectWithValue({ loading: false })
    } catch (err) {
      if (axios.isCancel(err)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)
export const getHighestPerformance = createAsyncThunk(
  'portfolioInsights/score/topCompanies/getHighestPerformance',
  async (params, { rejectWithValue }) => {
    try {
      const res = await portfolioScoreService.getHighestPerformance(params)
      if (res.success) {
        return res.data
      }
      return rejectWithValue({ loading: false })
    } catch (err) {
      if (axios.isCancel(err)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getBiggestCreditRisk = createAsyncThunk(
  'portfolioInsights/score/topCompanies/getBiggestCreditRisk',
  async (params, { rejectWithValue }) => {
    try {
      const res = await portfolioScoreService.getBiggestCreditRisk(params)
      if (res.success) {
        return res.data
      }
      return rejectWithValue({ loading: false })
    } catch (err) {
      if (axios.isCancel(err)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)
export const getBiggestPerformance = createAsyncThunk(
  'portfolioInsights/score/topCompanies/getBiggestPerformance',
  async (params, { rejectWithValue }) => {
    try {
      const res = await portfolioScoreService.getBiggestPerformance(params)
      if (res.success) {
        return res.data
      }
      return rejectWithValue({ loading: false })
    } catch (err) {
      if (axios.isCancel(err)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getLargestDeclineCreditRisk = createAsyncThunk(
  'portfolioInsights/score/topCompanies/getLargestDeclineCreditRisk',
  async (params, { rejectWithValue }) => {
    try {
      const res = await portfolioScoreService.getLargestDeclineCreditRisk(
        params,
      )
      if (res.success) {
        return res.data
      }
      return rejectWithValue({ loading: false })
    } catch (err) {
      if (axios.isCancel(err)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)
export const getLargestDeclinePerformance = createAsyncThunk(
  'portfolioInsights/score/topCompanies/getLargestDeclinePerformance',
  async (params, { rejectWithValue }) => {
    try {
      const res = await portfolioScoreService.getLargestDeclinePerformance(
        params,
      )
      if (res.success) {
        return res.data
      }
      return rejectWithValue({ loading: false })
    } catch (err) {
      if (axios.isCancel(err)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const exportTopCreditRiskScore = createAsyncThunk(
  'portfolio/score/exportTopCreditRiskScore',
  async (params, { rejectWithValue }) => {
    try {
      const response = await portfolioScoreService.exportTopCreditRiskScore(
        params,
      )
      handleExport(response.data, response.filename)
    } catch (error) {
      return rejectWithValue({ loading: false })
    }
  },
)

export const exportTopPerformanceScore = createAsyncThunk(
  'portfolio/score/exportTopPerformanceScore',
  async (params, { rejectWithValue }) => {
    try {
      const response = await portfolioScoreService.exportTopPerformanceScore(
        params,
      )
      handleExport(response.data, response.filename)
    } catch (error) {
      return rejectWithValue({ loading: false })
    }
  },
)
